module.exports = __webpack_public_path__ + "static/images/arrow-left.vnqyvJk.svg";